<div *ngIf="!showContent" class="loading-spinner">
    <mat-spinner></mat-spinner>
</div>

<ng-container *ngIf="showContent">

    <app-menu>
        <div class="form-container">
            <div class="step-content">
                <!-- Progress Bar above each step of form to detail which step is active-->
                <ul class="progress-bar">
                    <li [class.active]="step === 1" (click)="changeStep(1)">
                        <span class="icon"><i class="fas fa-person"></i></span>
                        <br>
                        <span class="label">Contacts</span>
                    </li>
                    <li [class.active]="step === 2" (click)="changeStep(2)">
                        <span class="icon"><i class="fas fa-truck-ramp-box"></i></span>
                        <br>
                        <span class="label">Load Details</span>
                    </li>
                    <li [class.active]="step === 3" (click)="changeStep(3)">
                        <span class="icon"><i class="fas fa-clock"></i></span>
                        <br>
                        <span class="label">Appointments</span>
                    </li>
                </ul>

                <!-- Contacts Form -->
                <div *ngIf="step === 1">
                    <form [formGroup]="contactForm">
                        <mat-checkbox (change)="toggleIntermodalLeg()">Add an Intemodal
                            leg?</mat-checkbox>
                        <mat-card *ngIf="addIntermodalLeg" class="card">
                            <mat-card-header class="contact-form-header-consignee">
                                <mat-card-title>
                                    Intermodal Leg
                                </mat-card-title>
                            </mat-card-header>
                            <mat-card-content>
                                <input type="text" formControlName="intermodal_contact_uuid" hidden="true">
                                <input type="text" formControlName="intermodal_address_uuid" hidden="true">                                
                                <div class="contact-form-details">
                                    <mat-form-field class="input-container">
                                        <mat-label>Consignee For Leg</mat-label>
                                        <mat-select formControlName="intermodal_company_name" required>
                                            <mat-option *ngFor="let type of typeListConsigneeLeg"
                                                [value]="type">{{type}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Street Address</mat-label>
                                        <input matInput placeholder="Street Address"
                                            formControlName="intermodal_address">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Street Address 2</mat-label>
                                        <input matInput placeholder="Street Address 2"
                                            formControlName="intermodal_address_line_two">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>City</mat-label>
                                        <input matInput placeholder="City" formControlName="intermodal_city">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Province/State</mat-label>
                                        <input matInput placeholder="Province/State"
                                            formControlName="intermodal_state_province_code">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Country</mat-label>
                                        <input matInput placeholder="Country" formControlName="intermodal_country_code">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Postal/Zip Code</mat-label>
                                        <input matInput placeholder="Postal/Zip Code"
                                            formControlName="intermodal_postal_code">
                                    </mat-form-field>
                                </div>
                            </mat-card-content>
                            <mat-card-header class="contact-form-header-carrier">
                                <mat-card-title>
                                    Intermodal Carrier Details
                                </mat-card-title>
                            </mat-card-header>
                            <mat-card-content>
                                <input type="text" formControlName="intermodal_carrier_contact_uuid" hidden="true">
                                <input type="text" formControlName="intermodal_carrier_address_uuid" hidden="true">
                                <div class="contact-form-details">
                                    <mat-form-field class="input-container">
                                        <mat-label>Company Name</mat-label>
                                        <mat-select formControlName="intermodal_carrier_company_name" (selectionChange)="handleSelectionChangeIntermodalCarrier($event)" >
                                            <mat-option *ngFor="let type of getValueCarrier()"
                                                [value]="type">{{type}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>                                    
                                    <mat-form-field class="input-container">
                                        <mat-label>Street Address</mat-label>
                                        <input matInput placeholder="Street Address"
                                            formControlName="intermodal_carrier_address_street">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Street Address 2</mat-label>
                                        <input matInput placeholder="Street Address"
                                            formControlName="intermodal_carrier_address_line_two">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>City</mat-label>
                                        <input matInput placeholder="City" formControlName="intermodal_carrier_address_locality">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Province/State</mat-label>
                                        <input matInput placeholder="Province/State"
                                            formControlName="intermodal_carrier_address_region">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Country</mat-label>
                                        <input matInput placeholder="Country" 
                                            formControlName="intermodal_carrier_address_country">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Postal/Zip Code</mat-label>
                                        <input matInput placeholder="Postal/Zip Code"
                                            formControlName="intermodal_carrier_address_postal_code">
                                    </mat-form-field>
                                </div>
                            </mat-card-content>
                        </mat-card>
                        <mat-card class="card">
                            <mat-card-header class="contact-form-header-shipper">
                                <mat-card-title>
                                    Shipper Details
                                </mat-card-title>
                            </mat-card-header>
                            <mat-card-content>
                                <input type="text" formControlName="shipper_contact_uuid" hidden="true">
                                <input type="text" formControlName="shipper_address_uuid" hidden="true">
                                <div class="contact-form-details">
                                    <mat-form-field class="input-container">
                                        <mat-label>Company Name</mat-label>
                                        <mat-select formControlName="shipper_company_name" (selectionChange)="handleSelectionChange($event)" required>
                                            <mat-option *ngFor="let type of getValueShipper()"
                                                [value]="type">{{type}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Street Address</mat-label>
                                        <input matInput placeholder="Street Address"
                                            formControlName="shipper_address_street">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Street Address 2</mat-label>
                                        <input matInput placeholder="Street Address 2"
                                            formControlName="shipper_address_extended">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>City</mat-label>
                                        <input matInput placeholder="City" formControlName="shipper_address_locality">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Province/State</mat-label>
                                        <input matInput placeholder="Province/State"
                                            formControlName="shipper_address_region">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Country</mat-label>
                                        <input matInput placeholder="Country" formControlName="shipper_address_country">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Postal/Zip Code</mat-label>
                                        <input matInput placeholder="Postal/Zip Code"
                                            formControlName="shipper_address_postal_code">
                                    </mat-form-field>
                                </div>
                            </mat-card-content>
                        </mat-card>
                        <mat-card class="card">
                            <mat-card-header class="contact-form-header-consignee">
                                <mat-card-title>
                                    Consignee Details
                                </mat-card-title>
                            </mat-card-header>
                            <mat-card-content>
                                <div class="address-reconcile-actions">
                                    <button mat-stroked-button color="primary" type="button"
                                        [disabled]="isReconcilingAddress || isLoading"
                                        (click)="reconcileAddress()">
                                        {{ isReconcilingAddress ? 'Reconciling address…' : 'Reconcile address' }}
                                    </button>
                                    <span *ngIf="addressReconcileMessage" role="status"
                                        class="address-reconcile-message" [class.address-reconcile-error]="addressReconcileError">
                                        {{ addressReconcileMessage }}
                                    </span>
                                </div>
                                <input type="text" formControlName="consignee_contact_uuid" hidden="true">
                                <input type="text" formControlName="consignee_address_uuid" hidden="true">
                                <div class="contact-form-details">
                                    <mat-form-field class="input-container">
                                        <mat-label>Company Name</mat-label>
                                        <input matInput placeholder="Company Name"
                                            formControlName="consignee_company_name">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Street Address</mat-label>
                                        <input matInput placeholder="Street Address"
                                            formControlName="consignee_address_street">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>City</mat-label>
                                        <input matInput placeholder="City" formControlName="consignee_address_locality">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Province/State</mat-label>
                                        <input matInput placeholder="Province/State"
                                            formControlName="consignee_address_region">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Country</mat-label>
                                        <input matInput placeholder="Country"
                                            formControlName="consignee_address_country">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Postal/Zip Code</mat-label>
                                        <input matInput placeholder="Postal/Zip Code"
                                            formControlName="consignee_address_postal_code">
                                    </mat-form-field>
                                </div>
                            </mat-card-content>
                        </mat-card>
                        <mat-card class="card">
                            <mat-card-header class="contact-form-header-carrier">
                                <mat-card-title>
                                    Carrier Details
                                </mat-card-title>
                            </mat-card-header>
                            <mat-card-content>
                                <input type="text" formControlName="carrier_contact_uuid" hidden="true">
                                <input type="text" formControlName="carrier_address_uuid" hidden="true">
                                <div class="contact-form-details">
                                    <mat-form-field class="input-container">
                                        <mat-label>Company Name</mat-label>
                                        <mat-select formControlName="carrier_company_name" (selectionChange)="handleSelectionChangeCarrier($event)" >
                                            <mat-option *ngFor="let type of getValueCarrier()"
                                                [value]="type">{{type}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>                                    
                                    <mat-form-field class="input-container">
                                        <mat-label>Street Address</mat-label>
                                        <input matInput placeholder="Street Address"
                                            formControlName="carrier_address_street">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Street Address 2</mat-label>
                                        <input matInput placeholder="Street Address"
                                            formControlName="carrier_address_line_two">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>City</mat-label>
                                        <input matInput placeholder="City" formControlName="carrier_address_locality">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Province/State</mat-label>
                                        <input matInput placeholder="Province/State"
                                            formControlName="carrier_address_region">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Country</mat-label>
                                        <input matInput placeholder="Country" formControlName="carrier_address_country">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Postal/Zip Code</mat-label>
                                        <input matInput placeholder="Postal/Zip Code"
                                            formControlName="carrier_address_postal_code">
                                    </mat-form-field>
                                </div>
                            </mat-card-content>
                        </mat-card>
                        <mat-card class="card">
                            <mat-card-header class="contact-form-header-customer">
                                <mat-card-title>
                                    Customer Details
                                </mat-card-title>
                            </mat-card-header>
                            <mat-card-content>
                                <input type="text" formControlName="customer_contact_uuid" hidden="true">
                                <input type="text" formControlName="customer_address_uuid" hidden="true">
                                <div class="contact-form-details">
                                    <mat-form-field class="input-container">
                                        <mat-label>Company Name</mat-label>
                                        <input matInput placeholder="Company Name"
                                            formControlName="customer_company_name">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Street Address</mat-label>
                                        <input matInput placeholder="Street Address" formControlName="customer_address">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>City</mat-label>
                                        <input matInput placeholder="City" formControlName="customer_city">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Province/State</mat-label>
                                        <input matInput placeholder="Province/State" formControlName="customer_region">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Country</mat-label>
                                        <input matInput placeholder="Country" formControlName="customer_country_code">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Postal/Zip Code</mat-label>
                                        <input matInput placeholder="Postal/Zip Code"
                                            formControlName="customer_postal_code">
                                    </mat-form-field>
                                </div>
                            </mat-card-content>
                        </mat-card>
                        <div class="form-actions-container">
                            <div class="form-actions">
                                <button mat-raised-button color="primary" (click)="prevStep()">Back</button>
                                <button mat-raised-button color="primary" (click)="nextStep()">Next</button>
                            </div>
                        </div>
                    </form>
                </div>
                <div *ngIf="step === 2">
                    <form [formGroup]="loadDetailsForm">
                        <mat-card *ngIf="typeListContainers.length > 1" class="card">
                            <mat-card-header class="contact-form-header-customer">
                                <mat-card-title>
                                    Container
                                </mat-card-title>
                            </mat-card-header>
                            <mat-card-content>
                                <div style="margin-top: 28px; margin-right: 25px;">
                                    <mat-form-field class="input-container">
                                        <mat-label>Container</mat-label>
                                        <mat-select formControlName="container" required>
                                            <mat-option *ngFor="let type of typeListContainers"
                                                [value]="type">{{type}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </mat-card-content>
                        </mat-card>
                        <mat-card class="card">
                            <mat-card-header class="contact-form-header-customer">
                                <mat-card-title>
                                    Pickup
                                </mat-card-title>
                            </mat-card-header>
                            <mat-card-content>
                                <div class="load-form-details-pickup">
                                    <mat-form-field class="input-container">
                                        <mat-label>Bill Of Lading</mat-label>
                                        <input matInput placeholder="BOL" formControlName="bill_of_lading">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>ASN Number</mat-label>
                                        <input matInput placeholder="ASN" formControlName="asn_number">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Trip Number</mat-label>
                                        <input matInput placeholder="ASN" formControlName="trip_number">
                                    </mat-form-field>                                    
                                    <mat-form-field class="input-container">
                                        <mat-label>Shipment Number</mat-label>
                                        <input matInput placeholder="Shipment NO." formControlName="shipment_number">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Booking Number</mat-label>
                                        <input matInput placeholder="Booking NO." formControlName="booking_number">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Detail</mat-label>
                                        <input matInput placeholder="Load Detils" formControlName="load_details">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Special Info</mat-label>
                                        <input matInput placeholder="Load Special Info"
                                            formControlName="load_special_info">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Weight</mat-label>
                                        <input matInput placeholder="Weight" formControlName="load_weight">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Actual Weight</mat-label>
                                        <input matInput placeholder="Actual Weight"
                                            formControlName="load_actual_weight">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Load Length</mat-label>
                                        <input matInput placeholder="Load Length" formControlName="load_length">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Pieces</mat-label>
                                        <input matInput placeholder="Pieces" formControlName="load_pieces">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Pallets</mat-label>
                                        <input matInput placeholder="Load Pallets" formControlName="load_pallets">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Value</mat-label>
                                        <input matInput placeholder="Value" formControlName="load_value">
                                    </mat-form-field>
                                </div>
                            </mat-card-content>
                        </mat-card>
                        <mat-card class="card">
                            <mat-card-header class="contact-form-header-carrier">
                                <mat-card-title>
                                    Pallet Information
                                </mat-card-title>
                            </mat-card-header>
                            <mat-card-content>
                                <ag-grid-angular style="height: 270px; margin:20px" class="ag-theme-alpine"
                                    [columnDefs]="palletsColumnDefs" [rowData]="pallets"
                                    [defaultColDef]="defaultColDef"></ag-grid-angular>
                            </mat-card-content>
                        </mat-card>
                        <div class="form-actions-container">
                            <div class="form-actions">
                                <button mat-raised-button color="primary" (click)="prevStep()">Back</button>
                                <button mat-raised-button color="primary" (click)="nextStep()">Next</button>
                            </div>
                        </div>
                    </form>
                </div>
                <div *ngIf="step === 3">
                    <form [formGroup]="appointmentForm">
                        <mat-card *ngIf="addIntermodalLeg" class="card">
                            <mat-card-header class="contact-form-header-shipper">
                                <mat-card-title>
                                    Intermodal Leg Pickup
                                </mat-card-title>
                            </mat-card-header>
                            <mat-card-content>
                                <div class="appointment-form-details-pickup">
                                    <mat-form-field class="input-container">
                                        <mat-label>Pick-up Date</mat-label>
                                        <input matInput [matDatepicker]="intermodal_date_pickup" formControlName="intermodal_date_pickup">
                                        <mat-hint>MM/DD/YYYY</mat-hint>
                                        <mat-datepicker-toggle matIconSuffix [for]="intermodal_date_pickup"></mat-datepicker-toggle>
                                        <mat-datepicker #intermodal_date_pickup></mat-datepicker>
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Pick-up Time Start</mat-label>
                                        <input matInput  type="time" 
                                            formControlName="intermodal_time_start_pickup">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Pick-up Time End</mat-label>
                                        <input matInput  type="time" 
                                            formControlName="intermodal_time_end_pickup">
                                    </mat-form-field>
                                </div>
                            </mat-card-content>
                        </mat-card>
                        <mat-card class="card">
                            <mat-card-header class="contact-form-header-consignee">
                                <mat-card-title>
                                    Pickup Appointment
                                </mat-card-title>
                            </mat-card-header>
                            <mat-card-content>
                                <div class="appointment-form-details-pickup">
                                    <mat-form-field class="input-container">
                                        <mat-label>Pick-up Date</mat-label>
                                        <input matInput [matDatepicker]="appointment_date_pickup" formControlName="appointment_date_pickup">
                                        <mat-hint>MM/DD/YYYY</mat-hint>
                                        <mat-datepicker-toggle matIconSuffix [for]="appointment_date_pickup"></mat-datepicker-toggle>
                                        <mat-datepicker #appointment_date_pickup></mat-datepicker>
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Pick-up Time Start</mat-label>
                                        <input matInput  type="time" 
                                            formControlName="appointment_time_start_pickup">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Pick-up Time End</mat-label>
                                        <input matInput  type="time" 
                                            formControlName="appointment_time_end_pickup">
                                    </mat-form-field>
                                </div>
                            </mat-card-content>
                        </mat-card>
                        <mat-card class="card">
                            <mat-card-header class="appointment-form-header-delivery">
                                <mat-card-title>
                                    Delivery 01
                                </mat-card-title>
                            </mat-card-header>
                            <mat-card-content>
                                <div class="load-form-details-pickup">
                                    <mat-form-field class="input-container">
                                        <mat-label>Carrier Pro Bill</mat-label>
                                        <input matInput placeholder="Carrier Pro Bill" formControlName="pro_bill_01">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Delivery Date</mat-label>
                                        <input matInput [matDatepicker]="appointment_date_delivery_01" formControlName="appointment_date_delivery_01" [placeholder]="shipment_details.operation?.appointment_day || ''">
                                        <mat-hint>MM/DD/YYYY</mat-hint>
                                        <mat-datepicker-toggle matIconSuffix [for]="appointment_date_delivery_01"></mat-datepicker-toggle>
                                        <mat-datepicker #appointment_date_delivery_01></mat-datepicker>
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Delivery Time Start</mat-label>
                                        <input matInput  type="time" 
                                            formControlName="appointment_time_start_delivery_01">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Delivery Time End</mat-label>
                                        <input matInput  type="time" 
                                            formControlName="appointment_time_end_delivery_01">
                                    </mat-form-field>
                                    <div class="input-container">
                                        <mat-label>Appointment Day Of The Week</mat-label><br>
                                        <mat-label>{{appointment_day_of_the_week}}</mat-label>
                                    </div>                                         
                                    <mat-form-field class="input-container">
                                        <mat-label>Appointment Date</mat-label>
                                        <input matInput [matDatepicker]="appointment_date_01" formControlName="appointment_date_01" [placeholder]="shipment_details.operation?.appointment_day || ''">
                                        <mat-hint>MM/DD/YYYY</mat-hint>
                                        <mat-datepicker-toggle matIconSuffix  [for]="appointment_date_01"></mat-datepicker-toggle>
                                        <mat-datepicker #appointment_date_01></mat-datepicker>                                        
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Appointment Time Start</mat-label>
                                        <input matInput  type="time" 
                                            formControlName="appointment_time_start_delivery_01">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Appointment Time End</mat-label>
                                        <input matInput  type="time" 
                                            formControlName="appointment_time_end_delivery_01">
                                    </mat-form-field>
                                </div>
                                <h2 style="margin-left: 10px;">Site Contact Person</h2>
                                <div class="load-form-details-pickup">
                                    <mat-form-field class="input-container">
                                        <mat-label>First Name:</mat-label>
                                        <input matInput placeholder="First Name:"
                                            formControlName="primary_on_site_first_name_01">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Last Name:</mat-label>
                                        <input matInput placeholder="Last Name:"
                                            formControlName="primary_on_site_last_name_01">
                                    </mat-form-field>
                                </div>
                            </mat-card-content>
                        </mat-card>

                    </form>
                    <form [formGroup]="deliveryLoad02Form">
                        <mat-card class="card" *ngIf="load_02">
                            <mat-card-header class="appointment-form-header-delivery">
                                <mat-card-title>
                                    Delivery 02
                                </mat-card-title>
                            </mat-card-header>
                            <mat-card-content>
                                <div class="load-form-details-pickup">
                                    <mat-form-field class="input-container">
                                        <mat-label>Carrier Pro Bill</mat-label>
                                        <input matInput placeholder="Carrier Pro Bill" formControlName="pro_bill_02">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Delivery Date</mat-label>
                                        <input matInput [matDatepicker]="appointment_date_delivery_02" formControlName="appointment_date_delivery_02" [placeholder]="shipment_details.operation?.appointment_day || ''">
                                        <mat-hint>MM/DD/YYYY</mat-hint>
                                        <mat-datepicker-toggle matIconSuffix [for]="appointment_date_delivery_02"></mat-datepicker-toggle>
                                        <mat-datepicker #appointment_date_delivery_02></mat-datepicker>
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Delivery Time Start</mat-label>
                                        <input matInput type="time" 
                                            formControlName="appointment_time_start_delivery_02">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Delivery Time End</mat-label>
                                        <input matInput  type="time" 
                                            formControlName="appointment_time_end_delivery_02">
                                    </mat-form-field>
                                    <div class="input-container">
                                        <mat-label>Appointment Day Of The Week</mat-label><br>
                                        <mat-label>{{appointment_day_of_the_week}}</mat-label>
                                    </div>                                      
                                    <mat-form-field>
                                        <mat-label>Appointment Date</mat-label>
                                        <input matInput [matDatepicker]="appointment_date_02" formControlName="appointment_date_02" [placeholder]="shipment_details.operation?.appointment_day || ''">
                                        <mat-hint>MM/DD/YYYY</mat-hint>
                                        <mat-datepicker-toggle matIconSuffix [for]="appointment_date_02"></mat-datepicker-toggle>
                                        <mat-datepicker #appointment_date_02></mat-datepicker>
                                    </mat-form-field>                                    
                                    <mat-form-field class="input-container">
                                        <mat-label>Appointment Time Start</mat-label>
                                        <input matInput  type="time" 
                                            formControlName="appointment_time_start_02">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Appointment Time End</mat-label>
                                        <input matInput  type="time" 
                                            formControlName="appointment_time_end_02">
                                    </mat-form-field>
                                </div>
                                <h2 style="margin-left: 10px;">Site Contact Person</h2>
                                <div class="load-form-details-pickup">
                                    <mat-form-field class="input-container">
                                        <mat-label>First Name:</mat-label>
                                        <input matInput placeholder="First Name:"
                                            formControlName="primary_on_site_first_name_02">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Last Name:</mat-label>
                                        <input matInput placeholder="Last Name:"
                                            formControlName="primary_on_site_last_name_02">
                                    </mat-form-field>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </form>
                    <form [formGroup]="deliveryLoad03Form">
                        <mat-card class="card" *ngIf="load_03">
                            <mat-card-header class="appointment-form-header-delivery">
                                <mat-card-title>
                                    Delivery 03
                                </mat-card-title>
                            </mat-card-header>
                            <mat-card-content>
                                <div class="load-form-details-pickup">
                                    <mat-form-field class="input-container">
                                        <mat-label>Carrier Pro Bill</mat-label>
                                        <input matInput placeholder="Carrier Pro Bill" formControlName="pro_bill_03">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Delivery Date</mat-label>
                                        <input matInput [matDatepicker]="appointment_date_delivery_03" formControlName="appointment_date_delivery_03" [placeholder]="shipment_details.operation?.appointment_day || ''">
                                        <mat-hint>MM/DD/YYYY</mat-hint>
                                        <mat-datepicker-toggle matIconSuffix [for]="appointment_date_delivery_03"></mat-datepicker-toggle>
                                        <mat-datepicker #appointment_date_delivery_03></mat-datepicker>
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Delivery Time Start</mat-label>
                                        <input matInput type="time" 
                                            formControlName="appointment_time_start_delivery_03">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Delivery Time End</mat-label>
                                        <input matInput  type="time" 
                                            formControlName="appointment_time_end_delivery_03">
                                    </mat-form-field>
                                    <div class="input-container">
                                        <mat-label>Appointment Day Of The Week</mat-label><br>
                                        <mat-label>{{appointment_day_of_the_week}}</mat-label>
                                    </div>                                       
                                    <mat-form-field class="input-container">
                                        <mat-label>Appointment Date</mat-label>
                                        <input matInput [matDatepicker]="appointment_date_03" formControlName="appointment_date_03" [placeholder]="shipment_details.operation?.appointment_day || ''">
                                        <mat-hint>MM/DD/YYYY</mat-hint>
                                        <mat-datepicker-toggle matIconSuffix [for]="appointment_date_03"></mat-datepicker-toggle>
                                        <mat-datepicker #appointment_date_03></mat-datepicker>
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Appointment Time Start</mat-label>
                                        <input matInput  type="time" 
                                            formControlName="appointment_time_start_03">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Appointment Time End</mat-label>
                                        <input matInput  type="time" 
                                            formControlName="appointment_time_end_03">
                                    </mat-form-field>
                                </div>
                                <h2 style="margin-left: 10px;">Site Contact Person</h2>
                                <div class="load-form-details-pickup">
                                    <mat-form-field class="input-container">
                                        <mat-label>First Name:</mat-label>
                                        <input matInput placeholder="First Name:"
                                            formControlName="primary_on_site_first_name_03">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Last Name:</mat-label>
                                        <input matInput placeholder="Last Name:"
                                            formControlName="primary_on_site_last_name_03">
                                    </mat-form-field>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </form>

                    <form [formGroup]="appointmentForm">
                        <!-- Temporary taken out for debugging                        
                        <mat-card class="card">
                            <mat-card-header class="appointment-form-header-site-contact">
                                <mat-card-title>
                                    Consignee Contact Date
                                </mat-card-title>
                            </mat-card-header>
                            <mat-card-content>
                                <div class="appointment-form-details-pickup">
                                    <mat-form-field class="input-container">
                                        <mat-label>Consignee Contact Date</mat-label>
                                        <input placeholder="Date Store was Called" matInput
                                            placeholer="Consignee Contact Date" [matDatepicker]="ConsigneeContactDate"
                                            formControlName="ConsigneeContactDate">
                                        <mat-hint>MM/DD/YYYY</mat-hint>
                                        <mat-datepicker-toggle matIconSuffix
                                            [for]="ConsigneeContactDate"></mat-datepicker-toggle>
                                        <mat-datepicker #ConsigneeContactDate></mat-datepicker>
                                    </mat-form-field>
                                </div>
                            </mat-card-content>
                        </mat-card>
                        -->                        
                        <div class="form-actions-container">
                            <div class="form-actions">
                                <button mat-raised-button color="primary" (click)="prevStep()">Back</button>
                                <button mat-raised-button color="primary" [disabled]="isReconcilingAddress || isLoading" (click)="submit()">{{ pendingCreationRequest ? 'Check creation status' : 'Submit' }}</button>
                            </div>
                        </div>
                        <div *ngIf="isLoading" class="spinner">
                            <mat-spinner></mat-spinner>
                          </div>
                    </form>

                </div>
            </div>
        </div>
    </app-menu>
</ng-container>